// import boot, { App } from './components/bootstrap';
import { globals } from "./registry";

import.meta.glob([
  '../images/**',
  '../fonts/**',
]);

globals.forEach(g => g());

// interface WindowWithApp extends Window {
//     app: App;
// }

// (window as WindowWithApp).app = boot();
//
// document.addEventListener('DOMContentLoaded', () => {
//     const el = document.getElementById('primary-navigation');
//     if (el && 'app' in window && 'renderPrimaryNav' in window.app) {
//         const props = JSON.parse(el.getAttribute('data-props') || '{"menuItems": []}');
//         window.app.renderPrimaryNav(el, props);
//     }
// });
